export const DescriptionSecuityCodeCard = () => {
  return (
    <div className="flex flex-col mt-1">
      <p className="text-[#FFFFFF] text-[13px] leading-[22px]">
        Your new recovery code file will be password-protected and sent to you
        via email. To unlock it, use a code composed of the last 4 digits of
        your phone number, followed by your 4-character passcode.Your passcode
        may include alphanumeric and special characters, it is case-sensitive.
      </p>
      <p className="font-semibold text-[#FFFFFF] text-[13px] leading-[22px]">
        Format:
      </p>
      <p className="font-semibold text-[#FFFFFF] text-[13px] leading-[22px]">
        [Last 4 digits of phone][4-character passcode]
      </p>
      <p className=" text-[#FFFFFF] text-[13px] leading-[22px]">
        Example: If your phone number is 123456 and your passcode is ABCD, the
        unlock code is 3456ABCD.If your passcode is @$cd, then your unlock code
        is 1234@$cd.
      </p>
      <p className="text-[#FFFFFF] text-[13px] leading-[22px]">
        Please note that your passcode is not stored, and we cannot recover your
        file if it is lost.
      </p>
    </div>
  )
}
